import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiMenuExpandableMultiSelectItemSearchComponent } from './fi-menu-expandable-multi-select-item-search.component';
import { CdkFixedSizeVirtualScroll, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatMenuItem } from '@angular/material/menu';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { MatIconButton } from '@angular/material/button';

@NgModule({
    imports: [
        CommonModule,
        CdkFixedSizeVirtualScroll,
        CdkVirtualScrollViewport,
        FiAppTextSharedModule,
        FiProfileIconModule,
        FormsModule,
        MatCheckbox,
        MatDivider,
        MatFormField,
        MatIcon,
        MatInput,
        MatMenuItem,
        MatPrefix,
        FiWhenScrolledModule,
        MatIconButton,
    ],
    declarations: [FiMenuExpandableMultiSelectItemSearchComponent],
    exports: [FiMenuExpandableMultiSelectItemSearchComponent],
})
export class FiMenuExpandableMultiSelectItemSearchModule {}
